import { QuestionExplanation } from '../../types'

export const TAALBEGRIP_EXPLANATIONS: Record<string, QuestionExplanation> = {
  'TAAL-STOF-L1-001': {
    id: 'TAAL-STOF-L1-001',
    explanation:
      'Een stoffelijk bijvoeglijk naamwoord vertelt van welke stof iets gemaakt is. "Houten" komt van "hout", dus de tafel is van hout gemaakt.',
    distractorExplanations: {
      '1': '"Tafel" is een zelfstandig naamwoord (een ding), geen bijvoeglijk naamwoord.',
      '2': '"Een" is een lidwoord, geen bijvoeglijk naamwoord.',
      '3': 'Er staat wel degelijk een stoffelijk bijvoeglijk naamwoord in de zin!',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Stoffelijk Bijvoeglijk Naamwoord',
        content:
          'Een stoffelijk bijvoeglijk naamwoord vertelt van welke stof iets gemaakt is. Bijvoorbeeld: houten (van hout), gouden (van goud), stenen (van steen).',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'TAAL-STOF-L1-002': {
    id: 'TAAL-STOF-L1-002',
    explanation:
      '"Gouden" is een stoffelijk bijvoeglijk naamwoord. Het komt van "goud" en vertelt dat de ring van goud gemaakt is.',
    distractorExplanations: {
      '1': '"Ring" is een zelfstandig naamwoord, geen bijvoeglijk naamwoord.',
      '2': '"Een" is een lidwoord.',
      '3': 'Er staat wel een stoffelijk bijvoeglijk naamwoord in de zin!',
    },
  },
  'TAAL-STOF-L1-003': {
    id: 'TAAL-STOF-L1-003',
    explanation:
      '"Stenen" vertelt dat de muur van steen gemaakt is. Dit is een stoffelijk bijvoeglijk naamwoord.',
    distractorExplanations: {
      '1': '"Muur" is het zelfstandig naamwoord (het ding).',
      '2': '"Een" is een lidwoord.',
      '3': 'Niet alle woorden, alleen "stenen" vertelt van welke stof de muur is.',
    },
  },
  'TAAL-STOF-L1-004': {
    id: 'TAAL-STOF-L1-004',
    explanation:
      'Van "hout" maak je het stoffelijke bijvoeglijk naamwoord "houten". Een deur van hout is een houten deur.',
    distractorExplanations: {
      '1': '"Houte" bestaat niet in het Nederlands.',
      '2': '"Houts" is geen correct Nederlands woord.',
      '3': '"Houten deur" is te lang - je hebt alleen het bijvoeglijk naamwoord "houten" nodig.',
    },
  },
  'TAAL-STOF-L2-001': {
    id: 'TAAL-STOF-L2-001',
    explanation:
      '"Ijzeren" is een stoffelijk bijvoeglijk naamwoord - het vertelt dat de poort van ijzer gemaakt is.',
    distractorExplanations: {
      '1': '"Grote" is een gewoon bijvoeglijk naamwoord (het zegt hoe groot), geen stoffelijk.',
      '2': 'Deze zin heeft helemaal geen bijvoeglijk naamwoord.',
      '3': '"Zware" is een gewoon bijvoeglijk naamwoord, geen stoffelijk.',
    },
  },
  'TAAL-STOF-L2-002': {
    id: 'TAAL-STOF-L2-002',
    explanation:
      'Van "zilver" maak je "zilveren". Een lepel van zilver is een zilveren lepel.',
    distractorExplanations: {
      '1': '"Zilver" is de stof zelf, niet het bijvoeglijk naamwoord.',
      '2': '"Zilvere" bestaat niet.',
      '3': '"Zilvers" is geen correct Nederlands woord.',
    },
  },
  'TAAL-STOF-L2-003': {
    id: 'TAAL-STOF-L2-003',
    explanation:
      '"Mooie" is een gewoon bijvoeglijk naamwoord. Het vertelt niet van welke stof iets gemaakt is.',
    distractorExplanations: {
      '1': '"Houten" is wel stoffelijk - het komt van "hout".',
      '2': '"Gouden" is wel stoffelijk - het komt van "goud".',
      '3': '"Stenen" is wel stoffelijk - het komt van "steen".',
    },
  },
  'TAAL-STOF-L2-004': {
    id: 'TAAL-STOF-L2-004',
    explanation:
      '"Wollen" komt van "wol". Een wollen trui is dus van wol gemaakt.',
    distractorExplanations: {
      '1': 'Katoen zou "katoenen" zijn.',
      '2': 'Zijde zou "zijden" zijn.',
      '3': 'Leer zou "leren" zijn.',
    },
  },
  'TAAL-STOF-L3-001': {
    id: 'TAAL-STOF-L3-001',
    explanation:
      'Er staan 3 stoffelijke bijvoeglijke naamwoorden: "houten" (van hout), "ijzeren" (van ijzer) en "stenen" (van steen).',
    distractorExplanations: {
      '1': 'Tel nog eens goed: houten, ijzeren, stenen - dat zijn er 3!',
      '2': 'Er is er nog één! Kijk goed naar alle woorden.',
      '3': 'Er staan er geen 4, tel nog eens na.',
    },
  },
  'TAAL-STOF-L3-002': {
    id: 'TAAL-STOF-L3-002',
    explanation:
      '"Een goud ring" is fout. Het moet "Een gouden ring" zijn. Je gebruikt het stoffelijke bijvoeglijk naamwoord, niet de stof zelf.',
    distractorExplanations: {
      '1': 'Dit is correct: "gouden" is het juiste stoffelijke bijvoeglijk naamwoord.',
      '2': 'Dit is correct: hier gebruik je "goud" als zelfstandig naamwoord.',
      '3': 'Dit is correct: "goud" is hier het onderwerp van de zin.',
    },
  },
  'TAAL-STOF-L3-003': {
    id: 'TAAL-STOF-L3-003',
    explanation:
      '"Zilveren" is een stoffelijk bijvoeglijk naamwoord dat vertelt dat de beker van zilver is.',
    distractorExplanations: {
      '1': '"Mooie" is een gewoon bijvoeglijk naamwoord, geen stoffelijk.',
      '2': '"Grote" is een gewoon bijvoeglijk naamwoord, geen stoffelijk.',
      '3': '"Volle" is een gewoon bijvoeglijk naamwoord, geen stoffelijk.',
    },
  },
  'TAAL-STOF-L3-004': {
    id: 'TAAL-STOF-L3-004',
    explanation:
      '"Glas" is de stof, "glazen" is het stoffelijke bijvoeglijk naamwoord. Een beker van glas is een glazen beker.',
    distractorExplanations: {
      '1': '"Groot" en "grote" zijn gewone bijvoeglijke naamwoorden, geen stoffelijke.',
      '2': '"Mooi" en "mooie" zijn gewone bijvoeglijke naamwoorden, geen stoffelijke.',
      '3': '"Rood" en "rode" zijn gewone bijvoeglijke naamwoorden (kleur), geen stoffelijke.',
    },
  },

  // NIEUW: BIJVOEGLIJKE NAAMWOORDEN (ALGEMEEN)
  'TAAL-BN-L1-001': {
    id: 'TAAL-BN-L1-001',
    explanation:
      'Een bijvoeglijk naamwoord vertelt iets over een zelfstandig naamwoord. "Rode" vertelt welke kleur de auto heeft. Rode is het bijvoeglijk naamwoord.',
    distractorExplanations: {
      '1': '"Auto" is een zelfstandig naamwoord (een ding), geen bijvoeglijk naamwoord.',
      '2': '"Rijdt" is een werkwoord (doe-woord), geen bijvoeglijk naamwoord.',
      '3': '"Snel" is een bijwoord (hoe rijdt de auto?), geen bijvoeglijk naamwoord.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Bijvoeglijk Naamwoord',
        content:
          'Een bijvoeglijk naamwoord vertelt iets over een zelfstandig naamwoord. Het zegt HOE iets is: groot, klein, mooi, rood, oud, nieuw.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'TAAL-BN-L1-002': {
    id: 'TAAL-BN-L1-002',
    explanation:
      '"Lieve" is het bijvoeglijk naamwoord. Het vertelt HOE het hondje is (lief). Bijvoeglijke naamwoorden vertellen iets over een zelfstandig naamwoord.',
    distractorExplanations: {
      '1': '"Hondje" is een zelfstandig naamwoord (een dier).',
      '2': '"Blaft" is een werkwoord (wat doet het hondje?).',
      '3': '"Het" is een lidwoord.',
    },
  },
  'TAAL-BN-L2-001': {
    id: 'TAAL-BN-L2-001',
    explanation:
      'Voor "de jongen" gebruik je "aardige" (met -e). Dit is de regel: bij de/het gebruik je meestal de vorm met -e.',
    distractorExplanations: {
      '1': '"Aardig" gebruik je bij "een jongen", niet bij "de jongen".',
      '2': '"Aardiger" is de vergrotende trap (meer aardig), dat past hier niet.',
      '3': '"Aardigst" is de overtreffende trap (het meest aardig), dat past hier niet.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Bijvoeglijk Naamwoord met -e',
        content:
          'Bij "de" of "het" krijgt het bijvoeglijk naamwoord meestal een -e: de aardige jongen, het mooie huis.',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'TAAL-BN-L2-002': {
    id: 'TAAL-BN-L2-002',
    explanation:
      'Er staan 2 bijvoeglijke naamwoorden in de zin: "oude" (vertelt hoe de man is) en "kromme" (vertelt hoe de stok is).',
    distractorExplanations: {
      '1': 'Tel nog eens: "oude" en "kromme" zijn allebei bijvoeglijke naamwoorden!',
      '2': 'Er staan geen 3 bijvoeglijke naamwoorden. "Loopt" is een werkwoord.',
      '3': 'Er staan wel bijvoeglijke naamwoorden! Zoek woorden die vertellen HOE iets is.',
    },
  },
  'TAAL-BN-L3-001': {
    id: 'TAAL-BN-L3-001',
    explanation:
      '"Lopen" is een werkwoord (doe-woord), geen bijvoeglijk naamwoord. Bijvoeglijke naamwoorden vertellen HOE iets is, werkwoorden vertellen WAT je doet.',
    distractorExplanations: {
      '1': '"Mooi" is wel een bijvoeglijk naamwoord (het vertelt hoe iets is).',
      '2': '"Groot" is wel een bijvoeglijk naamwoord.',
      '3': '"Klein" is wel een bijvoeglijk naamwoord.',
    },
  },

  // NIEUW: ZELFSTANDIGE NAAMWOORDEN
  'TAAL-ZN-L1-001': {
    id: 'TAAL-ZN-L1-001',
    explanation:
      'Een zelfstandig naamwoord is een mens, dier of ding. "Kat" is een dier, dus een zelfstandig naamwoord. Je kunt er "de" of "het" voor zetten: de kat.',
    distractorExplanations: {
      '1': '"Slaapt" is een werkwoord (wat doet de kat?).',
      '2': '"Op" is een voorzetsel (waar ligt de kat?).',
      '3': '"De" is een lidwoord.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Zelfstandig Naamwoord',
        content:
          'Een zelfstandig naamwoord is een mens, dier of ding. Je kunt er "de" of "het" voor zetten. Voorbeelden: de kat, het huis, de jongen.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'TAAL-ZN-L1-002': {
    id: 'TAAL-ZN-L1-002',
    explanation:
      '"Appel" is een zelfstandig naamwoord (een ding). Je kunt er "de" of "een" voor zetten: een appel, de appel.',
    distractorExplanations: {
      '1': '"Eet" is een werkwoord (wat doe je met de appel?).',
      '2': '"Lekkere" is een bijvoeglijk naamwoord (hoe is de appel?).',
      '3': '"Ik" is een persoonlijk voornaamwoord.',
    },
  },
  'TAAL-ZN-L2-001': {
    id: 'TAAL-ZN-L2-001',
    explanation:
      '"Fiets" is een ding, dus een zelfstandig naamwoord. Je kunt er "de" of "een" voor zetten: de fiets, een fiets.',
    distractorExplanations: {
      '1': '"Fietsen" is een werkwoord (wat doe je?).',
      '2': '"Snel" is een bijwoord (hoe fiets je?).',
      '3': '"Naar" is een voorzetsel (waar ga je heen?).',
    },
  },
  'TAAL-ZN-L2-002': {
    id: 'TAAL-ZN-L2-002',
    explanation:
      'Er staan 3 zelfstandige naamwoorden: "bakker" (mens), "brood" (ding) en "oven" (ding).',
    distractorExplanations: {
      '1': 'Tel nog eens: bakker, brood, oven - dat zijn er 3!',
      '2': 'Er staan geen 4 zelfstandige naamwoorden. "Bakt" is een werkwoord.',
      '3': 'Er staat meer dan 1 zelfstandig naamwoord! Zoek alle mensen, dieren en dingen.',
    },
  },
  'TAAL-ZN-L3-001': {
    id: 'TAAL-ZN-L3-001',
    explanation:
      '"Amsterdam" is een eigennaam - de naam van een stad. Eigennamen schrijf je altijd met een hoofdletter.',
    distractorExplanations: {
      '1': '"Stad" is een gewoon zelfstandig naamwoord, geen eigennaam.',
      '2': '"Groot" is een bijvoeglijk naamwoord, geen zelfstandig naamwoord.',
      '3': '"Wonen" is een werkwoord, geen zelfstandig naamwoord.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Eigennamen',
        content:
          'Eigennamen zijn namen van personen, plaatsen en landen. Ze beginnen altijd met een hoofdletter: Amsterdam, Jan, Nederland.',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },

  // NIEUW: WERKWOORDEN HERKENNEN
  'TAAL-WW-L1-001': {
    id: 'TAAL-WW-L1-001',
    explanation:
      'Een werkwoord (doe-woord) vertelt WAT je doet. "Rennen" vertelt wat wij doen. Je kunt vragen: Wat doen wij? → Rennen.',
    distractorExplanations: {
      '1': '"Wij" is een persoonlijk voornaamwoord, geen werkwoord.',
      '2': '"Naar" is een voorzetsel, geen werkwoord.',
      '3': '"School" is een zelfstandig naamwoord (een ding), geen werkwoord.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Werkwoord (Doe-woord)',
        content:
          'Een werkwoord vertelt WAT je doet. Vraag: Wat doe je? Voorbeelden: lopen, rennen, zwemmen, eten, slapen.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'TAAL-WW-L2-001': {
    id: 'TAAL-WW-L2-001',
    explanation:
      '"Tafel" is een zelfstandig naamwoord (een ding), geen werkwoord. Werkwoorden vertellen WAT je doet: lopen, zwemmen, denken.',
    distractorExplanations: {
      '1': '"Lopen" is wel een werkwoord (wat doe je?).',
      '2': '"Zwemmen" is wel een werkwoord.',
      '3': '"Denken" is wel een werkwoord.',
    },
  },
  'TAAL-WW-L2-002': {
    id: 'TAAL-WW-L2-002',
    explanation:
      'De persoonsvorm is het werkwoord dat bij het onderwerp hoort. "Fietste" is de persoonsvorm - het vertelt wat "ik" deed.',
    distractorExplanations: {
      '1': '"Gisteren" is een bijwoord van tijd, geen werkwoord.',
      '2': '"Ik" is een persoonlijk voornaamwoord, geen werkwoord.',
      '3': '"Huis" is een zelfstandig naamwoord, geen werkwoord.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Persoonsvorm',
        content:
          'De persoonsvorm is het werkwoord dat bij het onderwerp hoort. Het verandert mee met wie het doet: ik fiets, jij fietst, hij fietste.',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'TAAL-WW-L3-001': {
    id: 'TAAL-WW-L3-001',
    explanation:
      'Er staan 2 werkwoorden: "heb" (hulpwerkwoord) en "gezwommen" (voltooid deelwoord). Samen maken ze de voltooide tijd.',
    distractorExplanations: {
      '1': 'Er staat meer dan 1 werkwoord! "Heb" en "gezwommen" zijn allebei werkwoorden.',
      '2': 'Er staan geen 3 werkwoorden. "Gisteren" en "lekker" zijn geen werkwoorden.',
      '3': 'Er staan wel werkwoorden! Zoek woorden die vertellen wat je DOET.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Voltooide Tijd',
        content:
          'Bij voltooide tijd gebruik je twee werkwoorden: een hulpwerkwoord (heb/ben/is) en een voltooid deelwoord (gezwommen, gelopen).',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },

  // NIEUW: LIDWOORDEN
  'TAAL-LW-L1-001': {
    id: 'TAAL-LW-L1-001',
    explanation:
      'Bij "huis" gebruik je het lidwoord "het". Je zegt: het huis, niet de huis. Dit moet je uit je hoofd leren.',
    distractorExplanations: {
      '1': '"De" gebruik je bij andere woorden, zoals "de tafel" of "de stoel".',
      '2': '"Een" is een onbepaald lidwoord. Dat kan ook, maar "het" is het juiste bepaalde lidwoord.',
      '3': '"Die" is een aanwijzend voornaamwoord, geen lidwoord.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Lidwoorden: de of het',
        content:
          'Bij sommige woorden gebruik je "de", bij andere "het". Dit moet je uit je hoofd leren. Voorbeelden: het huis, de tafel, het boek, de stoel.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'TAAL-LW-L2-001': {
    id: 'TAAL-LW-L2-001',
    explanation:
      'Bij "tafel" gebruik je het lidwoord "de". Je zegt: de tafel. Dit moet je uit je hoofd leren.',
    distractorExplanations: {
      '1': '"Het" gebruik je bij andere woorden, zoals "het huis" of "het boek".',
      '2': '"Een" is een onbepaald lidwoord. Dat kan ook, maar "de" is het juiste bepaalde lidwoord.',
      '3': '"Geen" is een ontkennend woord, geen lidwoord.',
    },
  },
  'TAAL-LW-L2-002': {
    id: 'TAAL-LW-L2-002',
    explanation:
      'Bij "boek" gebruik je het lidwoord "het". Je zegt: het boek. Dit moet je uit je hoofd leren.',
    distractorExplanations: {
      '0': '"De" gebruik je bij andere woorden, zoals "de tafel" of "de stoel".',
      '2': '"Een" is een onbepaald lidwoord. Dat kan ook, maar "het" is het juiste bepaalde lidwoord.',
      '3': '"Geen" is een ontkennend woord, geen lidwoord.',
    },
  },
  'TAAL-LW-L3-001': {
    id: 'TAAL-LW-L3-001',
    explanation:
      '"Een" is een onbepaald lidwoord. Het wijst niet naar iets specifieks. "De" en "het" zijn bepaalde lidwoorden - ze wijzen naar iets specifieks.',
    distractorExplanations: {
      '1': '"De" is een bepaald lidwoord, geen onbepaald lidwoord.',
      '2': '"Het" is een bepaald lidwoord, geen onbepaald lidwoord.',
      '3': '"Die" is een aanwijzend voornaamwoord, geen lidwoord.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Bepaald vs Onbepaald Lidwoord',
        content:
          'Bepaalde lidwoorden: de, het (wijzen naar iets specifieks).\nOnbepaalde lidwoorden: een (wijst niet naar iets specifieks).\nVoorbeeld: "een huis" (zomaar een huis) vs "het huis" (dat specifieke huis).',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
}
